import { ListChecks } from "lucide-react";
import { useFetch } from "../lib/api";
import { Pill } from "./shared";

const STATUS = { complete: ["green", "Completed"], all_clear: ["green", "Nothing to fix"], in_progress: ["amber", "In progress"], not_started: ["red", "Not started"], not_checked: ["slate", "Not checked yet"] };

export const PeTodoProgressCard = () => {
  const { data } = useFetch("/pe/todo-progress");
  if (!data?.contractors?.length) return null;
  return (
    <div className="c-surface p-5 mb-6" data-testid="pe-todo-progress">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-white"><ListChecks size={16} className="text-amber-300" />Contractor to-do progress</div>
        <span className="text-xs text-slate-400" data-testid="pe-todo-summary">Week of {data.week} · {data.finished} of {data.contractors.length} finished</span>
      </div>
      <div className="grid gap-2">
        {data.contractors.map((c) => {
          const [tone, label] = STATUS[c.status];
          const pct = c.total ? Math.round((c.done / c.total) * 100) : c.status === "all_clear" ? 100 : 0;
          return (
            <div key={c.vendor_id} className="grid grid-cols-[1fr_auto] sm:grid-cols-[minmax(0,1fr)_160px_auto] items-center gap-3 py-2 border-b border-[#1F2A3E]/60 last:border-0" data-testid={`pe-todo-row-${c.vendor_id}`}>
              <div className="min-w-0 text-sm truncate">{c.vendor_name}{c.total > 0 && <span className="ml-2 text-xs text-slate-500">{c.done} of {c.total} done</span>}</div>
              <div className="hidden sm:block h-1.5 rounded-full bg-[#1F2A3E] overflow-hidden"><div className="h-full bg-[#00E599] transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>
              <Pill tone={tone} testid={`pe-todo-status-${c.vendor_id}`}>{label}</Pill>
            </div>);
        })}
      </div>
      <p className="text-[11px] text-slate-500 mt-3">Contractors tick items as they fix them; their records are re-checked each Monday or when they press Re-check.</p>
    </div>);
};
